// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xUgT","inner":"Footer_inner__2VftC","nextIcon":"Footer_nextIcon__736eN","innerLeft":"Footer_innerLeft__1cuu5"};